// project hash key
// e921d896b24ee51ad95dc303a034758da1187532b0a44189bd99aa333255781b
import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import { BREAK_POINT } from '../../../../constants';

const NumberDisplay = ({ number, isSmall = false }) => {
  const renderDigit = (digit) => {
    const dimensions = isSmall
      ? { pc: { width: 24, height: 46 }, mobile: { width: 19, height: 32 } }
      : { pc: { width: 40, height: 70 }, mobile: { width: 24, height: 46 } };

    return (
      <>
        <MediaQuery minWidth={BREAK_POINT + 1}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={dimensions.pc.width}
            height={dimensions.pc.height}
            viewBox="0 0 40 70"
          >
            <g transform="translate(-713 -1047)">
              <rect width="40" height="50" transform="translate(713 1060)" fill="#464646" />
              <text
                transform="translate(719 1103)"
                fill="#fff"
                fontSize="48"
                fontFamily="AOTFShinMaruGoPro"
                fontWeight="500"
              >
                <tspan x="0" y="0">
                  {digit}
                </tspan>
              </text>
            </g>
          </svg>
        </MediaQuery>
        <MediaQuery maxWidth={BREAK_POINT}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={dimensions.mobile.width}
            height={dimensions.mobile.height}
            viewBox="0 0 19 32"
          >
            <g transform="translate(49 -340.635)">
              <rect width="19" height="24" transform="translate(-49 346.635)" fill="#464646" />
              <text
                transform="translate(-46 366.635)"
                fill="#fff"
                fontSize="22"
                fontFamily="AOTFShinMaruGoPro"
                fontWeight="500"
              >
                <tspan x="0" y="0">
                  {digit}
                </tspan>
              </text>
            </g>
          </svg>
        </MediaQuery>
      </>
    );
  };

  if (number <= 9) {
    return (
      <>
        <div>{renderDigit(0)}</div>
        <div>{renderDigit(number)}</div>
      </>
    );
  }

  return (
    <>
      <div>{renderDigit(Math.floor(number / 10))}</div>
      <div>{renderDigit(number % 10)}</div>
    </>
  );
};

NumberDisplay.propTypes = {
  number: PropTypes.number.isRequired,
  isSmall: PropTypes.bool,
};

export default NumberDisplay;
